<template>
  <!-- ussage -->
  <!-- <Breadscrumbs :links="[{name: '', to: {path: ''}}]""></Breadscrumbs> -->
  <div class="breadscrumbs">
    <div v-for="(link, i) in links" :key="link.name" class="d-inline-block">
      <v-icon v-if="i != 0">chevron_right</v-icon>
      <router-link
        :to="link.to"
        class="breadscrumbs-item"
        :class="{ active: links.length - 1 == i }"
        >{{ link.name }}</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    links: {
      type: Array,
      default: () => [
        { to: { path: '/' }, name: 'HomePage' },
        { to: { path: '/aboutus' }, name: 'AboutUs' },
      ],
    },
  },
};
</script>
